(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

module.exports = _arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{}],2:[function(require,module,exports){
var arrayLikeToArray = require("./arrayLikeToArray.js");

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return arrayLikeToArray(arr);
}

module.exports = _arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{"./arrayLikeToArray.js":1}],3:[function(require,module,exports){
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{}],4:[function(require,module,exports){
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

module.exports = _iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{}],5:[function(require,module,exports){
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

module.exports = _nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{}],6:[function(require,module,exports){
var arrayWithoutHoles = require("./arrayWithoutHoles.js");

var iterableToArray = require("./iterableToArray.js");

var unsupportedIterableToArray = require("./unsupportedIterableToArray.js");

var nonIterableSpread = require("./nonIterableSpread.js");

function _toConsumableArray(arr) {
  return arrayWithoutHoles(arr) || iterableToArray(arr) || unsupportedIterableToArray(arr) || nonIterableSpread();
}

module.exports = _toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{"./arrayWithoutHoles.js":2,"./iterableToArray.js":4,"./nonIterableSpread.js":5,"./unsupportedIterableToArray.js":7}],7:[function(require,module,exports){
var arrayLikeToArray = require("./arrayLikeToArray.js");

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
}

module.exports = _unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{"./arrayLikeToArray.js":1}],8:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

/**
 * Block: Accordion
 */
(function () {
  var oakfndAccordion = function oakfndAccordion(elem) {
    var el = elem[0] === undefined ? elem : elem[0];
    var block = el.classList.contains('acf-block-preview') ? el.querySelector('.oakfnd-accordion') : el;
    (0, _toConsumableArray2.default)(block.querySelectorAll('.accordion-item')).forEach(function (item) {
      var accStyle = item.dataset && item.dataset.tabStyle && JSON.parse(item.dataset.tabStyle);
      var btn = item.querySelector('.accordion-button');
      var subHeader = btn.querySelector('div');
      var isOutlined = accStyle && accStyle.is_outlined;
      console.log(accStyle);

      if (btn.classList.contains('collapsed')) {
        btn.style.color = accStyle.default_text_color;
        btn.style.backgroundColor = !isOutlined ? accStyle.default_background_color : 'transparent';
        subHeader && subHeader.style.borderColor ? accStyle.default_text_color : '';
      }

      btn.addEventListener('click', function () {
        if (btn.classList.contains('collapsed')) {
          btn.style.color = accStyle.default_text_color;
          btn.style.backgroundColor = !isOutlined ? accStyle.default_background_color : 'transparent';
          subHeader && subHeader.style.borderColor ? accStyle.default_text_color : '';
        } else {
          btn.style.color = accStyle.active_text_color;
          btn.style.backgroundColor = !isOutlined ? accStyle.active_background_color : 'transparent';
          subHeader && subHeader.style.borderColor ? accStyle.active_text_color : '';
        }
      });
    });
  };

  document.querySelectorAll('.oakfnd-accordion').forEach(function (elem) {
    return oakfndAccordion(elem);
  });

  if (window.acf) {
    window.acf.addAction('render_block_preview/type=accordion', oakfndAccordion);
  }
})();

},{"@babel/runtime/helpers/interopRequireDefault":3,"@babel/runtime/helpers/toConsumableArray":6}]},{},[8]);
